import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card } from '../SubscriptionAppCard';
import { Badge } from '../SubscriptionAppBadge';
import { contactOrders } from '../../data/mockContactOrders';
import { channelBadgeVariant, orderTotal, summarizeChannels } from '../../utils/orderChannels';
import { formatShortDate } from '../../utils/dateFormat';
interface RecentPurchasesCardProps {
  onViewAllOrders: () => void;
}
const RECENT_COUNT = 4;

// The contact's last few orders, with products, channel and totals
export function RecentPurchasesCard({
  onViewAllOrders
}: RecentPurchasesCardProps) {
  const summary = summarizeChannels(contactOrders);
  const recent = [...contactOrders].sort((a, b) => b.date.localeCompare(a.date)).slice(0, RECENT_COUNT);
  return <Card padding="none" data-id="element-1702" data-mp="1h82ounx4fby7">
      <div className="p-6 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-1703" data-mp="1h7kszsedezqt">
        <div className="flex items-center justify-between" data-id="element-1704" data-mp="1c9j3aomfw26d">
          <h3 className="text-xl font-semibold text-[#0F172A]" data-id="element-1705" data-mp="1cb3vw8p71b1l">
            Recent Purchases
          </h3>
          <button type="button" onClick={onViewAllOrders} className="inline-flex items-center gap-1 text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-1706" data-mp="5socp0m2tubn">
            View all orders
            <ArrowRight className="w-3.5 h-3.5" data-id="element-1707" data-mp="jq36ehjd4o9f" />
          </button>
        </div>
        <p className="text-sm text-[#64748B] mt-1" data-id="element-1708" data-mp="jnz424143xb9">
          {summary.clubCount} club · {summary.oneTimeCount} one-time
        </p>
      </div>
      <ul className="bg-white rounded-b-lg divide-y divide-[#E2E8F0]" data-id="element-1709" data-mp="3o3i7ynd5bk4h">
        {recent.map(order => <li key={order.orderNumber} className="px-6 py-4" data-id="element-1710" data-mp="3s5d65izs5he1">
            <div className="flex items-baseline justify-between gap-4" data-id="element-1711" data-mp="3s4235le5sdnz">
              <div className="flex items-center gap-2 flex-wrap" data-id="element-1712" data-mp="ss8p1ddq2w3">
                <span className="text-sm font-semibold text-[#0F172A]" data-id="element-1713" data-mp="30fiidqrklzrh">
                  {formatShortDate(order.date)}
                </span>
                <span className="text-xs text-[#94A3B8]" data-id="element-1714" data-mp="34ehld5tqrmga">
                  {order.orderNumber}
                </span>
                <Badge variant={channelBadgeVariant(order.channel)} data-id="element-1715" data-mp="bjhc4ho4ib3g">
                  {order.channel}
                </Badge>
              </div>
              <span className="text-sm font-semibold text-[#0F172A]" data-id="element-1716" data-mp="laloraqbtjv4">
                ${orderTotal(order).toFixed(2)}
              </span>
            </div>
            <ul className="mt-1.5 space-y-0.5" data-id="element-1717" data-mp="3oscanddyk28b">
              {order.items.map(item => <li key={`${item.vintage}-${item.title}`} className="text-sm text-[#475569]" data-id="element-1718" data-mp="3osm1122x0bej">
                  {item.quantity}× {item.vintage} {item.title}
                </li>)}
            </ul>
          </li>)}
      </ul>
    </Card>;
}